export default function Products() {
  const products = [
    {
      name: 'VPN Pro',
      category: 'Security',
      description: 'Advanced VPN solution for iOS',
      image: 'https://public.readdy.ai/ai/img_res/1bcb0a2aa75f6a3dd9a23fa5b115e583.jpg'
    },
    {
      name: 'Cleaner Plus',
      category: 'Optimization',
      description: 'Powerful device optimization tool',
      image: 'https://readdy.ai/api/search-image?query=iOS%20cleaner%20app%20interface%20showing%20storage%20optimization%20and%20device%20cleaning%20features%2C%20modern%20minimalist%20design%20with%20circular%20progress%20indicators%2C%20clean%20white%20background%20with%20green%20accent%20colors&width=280&height=280&seq=product-cleaner&orientation=squarish'
    },
    {
      name: 'Security Suite',
      category: 'Protection',
      description: 'Complete security package',
      image: 'https://readdy.ai/api/search-image?query=comprehensive%20mobile%20security%20application%20interface%20with%20lock%20icons%20and%20protection%20shields%2C%20professional%20iOS%20app%20design%20with%20dark%20blue%20and%20teal%20colors%2C%20clean%20minimalist%20layout%20showing%20security%20features&width=280&height=280&seq=product-security&orientation=squarish'
    },
    {
      name: 'Speed Booster',
      category: 'Performance',
      description: 'Enhance device performance',
      image: 'https://readdy.ai/api/search-image?query=iOS%20performance%20optimization%20app%20showing%20speed%20meter%20and%20boost%20features%2C%20modern%20interface%20with%20dynamic%20gradient%20colors%2C%20clean%20white%20background%20with%20orange%20and%20blue%20accents%2C%20minimalist%20mobile%20app%20design&width=280&height=280&seq=product-booster&orientation=squarish'
    }
  ];

  return (
    <section id="products" className="py-32 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-20">
        <div className="flex items-end justify-between mb-16">
          <div>
            <h2 className="text-5xl font-bold text-gray-900">
              Our Flagship <span className="text-teal-600">Products</span>
            </h2>
            <p className="text-gray-500 mt-4 text-lg">Designed for modern iOS users</p>
          </div>
          <span className="px-4 py-2 bg-gray-900 text-white text-xs font-semibold tracking-wider rounded-full uppercase">
            Featured
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-product-shop>
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 cursor-pointer"
            >
              <div className="w-full h-[280px] mb-6 rounded-xl overflow-hidden bg-gray-100">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="space-y-2">
                <p className="text-sm text-gray-500">{product.category}</p>
                <h3 className="text-xl font-bold text-gray-900">{product.name}</h3>
                <p className="text-sm text-gray-600">{product.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
